/**
 * Web shim for react-native-keyboard-controller.
 *
 * Its keyboard-controller's animated implementation pulls
 * react-native-reanimated's createAnimatedComponent (not provided by our
 * reanimated web shim), which crashed the app layout at import time on web.
 * Web only needs a passthrough provider and a working KeyboardAvoidingView —
 * React Native's cross-platform one handles behavior="padding" on web.
 */
const RN = require('react-native');

module.exports = {
  __esModule: true,
  KeyboardProvider: ({ children }) => children,
  KeyboardAvoidingView: RN.KeyboardAvoidingView,
};